import { api as o } from "../utils/configuration.js";
import { crudService as t } from "../js/request-DH6Y2P3c.js";
const c = {
  getEnums: ([r], e) => t.get(`${o.ENUMERATION_URL}/${r}`, {
    signal: e
  })
};
export {
  c as EnumerationService
};
//# sourceMappingURL=enumeration.js.map
